function e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
export {
  e as default
};
//# sourceMappingURL=nonIterableRest.js.map
